<template>
    <div class="  con_content">
        <div class="container">
            <div class="container_top h_48">
                百度内容管理  
            </div>
            
            <div >

                <!-- table组件 -->
                <div class="my_table">
                    
                    <div class="my_search">
                        
                        <Row class="search_row">  
                            <div  class="search_name">                             
                                <Button class="mR5"    type="info"    @click='route="/layout/circle/classify/add";addFun();' > <Icon type="md-add" />添加</Button>                              
                            </div>
                            
                        </Row>
                     
                    </div>
                
                
                </div>
                <!-- table组件 -->
                <div class="my_table  ">
                    <Header class="my_title txt_l">
                        <span class="my_titleL">
                        <Icon class="fw_900 " type="ios-list" size='30'/>     
                            数据列表 
                        </span>
                        
                        <div class="ct_rgt">
                            
                            <!-- <div class="sta_btn " type="primary"   @click="exportData">导出数据</div> -->
                            
                        </div>
                    </Header>
                    <Table     border :columns="columns1" :data="data1" ref='table'>
                    
                        
                        
                       
                        <!-- 按钮 -->
                        <template slot-scope="{ row, index }" slot="btn">
                            <!-- <Poptip trigger="hover" :title="row.surname" content="查看"> -->
                            
                            <Poptip trigger="hover"   content="编辑">
                                <Button class="padlr5" size="small"  @click='route="/layout/circle/classify/editor";editorFun(row)'  type="success"      icon="md-open"></Button>
                            </Poptip>
                            <Poptip trigger="hover"  content="删除">
                                <Button class="padlr5"  size="small" @click='route="/layout/circle/classify/del";delFun(row)'  type="error"      icon="md-close"></Button>
                            </Poptip>
                        
                        </template>
                        
                    </Table>
                
                    <!-- 用户组添加弹窗 -->
                    <Modal
                        v-model="modal1"
                        title="分类编辑"
                    
                        class-name="vertical-center-modal"
                    >
                        <div slot="footer">
                            <Button type='text' size='large' @click='cancel1'>取消</Button>
                            <Button type='primary' size='large' @click='ok1'>修改</Button>
                        </div>
                        <ul class="list_ul">
                        
                                
                            <!-- 排序 -->
                            <li>
                                <div class='list_title'> <span class="cRed">*</span> 排序 :</div> 
                                <div class="list_con">
                                    <Input  v-model="model1"    type='text' class="ipt"  placeholder="请输入排序"    />
                                </div>                                            
                            </li>
                            <!-- 标题-->
                            <li>
                                <div class='list_title'> <span class="cRed">*</span> 标题 :</div> 
                                <div class="list_con">
                                    <Input   v-model="model2"   type='text' class="ipt"  placeholder="请输入标题"    />
                                </div>                                            
                            </li>
                            <!-- 链接 -->
                            <li>
                                <div class='list_title'> <span class="cRed">*</span> 链接 :</div> 
                                <div class="list_con">
                                    <Input   v-model="model4"   type='text' class="ipt"  placeholder="请输入链接"    />
                                </div>                                            
                            </li>                                              
                          
                        </ul>
                    </Modal>
                    

                    <!-- 用户组添加弹窗 -->
                    <Modal
                        v-model="modal2"
                        title="分类添加"
                    
                        class-name="vertical-center-modal"
                    >
                        <div slot="footer">
                            <Button type='text' size='large' @click='cancel_add'>取消</Button>
                            <Button type='primary' size='large' @click='ok_add'>添加</Button>
                        </div>
                        <ul class="list_ul">
                        
                                
                            <!-- 排序 -->
                            <li>
                                <div class='list_title'> <span class="cRed">*</span> 排序 :</div> 
                                <div class="list_con">
                                    <Input  v-model="model1"    type='text' class="ipt"  placeholder="请输入排序"    />
                                </div>                                            
                            </li>
                            <!-- 标题 -->
                            <li>
                                <div class='list_title'> <span class="cRed">*</span> 标题 :</div> 
                                <div class="list_con">
                                    <Input   v-model="model2"   type='text' class="ipt"  placeholder="请输入标题"    />
                                </div>                                            
                            </li>  
                            <!-- 链接 -->
                            <li>
                                <div class='list_title'> <span class="cRed">*</span> 链接 :</div> 
                                <div class="list_con">
                                    <Input   v-model="model4"   type='text' class="ipt"  placeholder="请输入链接"    />
                                </div>                                            
                            </li>                                               
                            <!-- 是否隐藏 -->
                            <li>
                                <div class='list_title'> <span class="cRed">*</span> 是否显示 :</div> 
                                <div class="list_con">
                                    <i-switch  class='model3 top5' v-model="model3" :true-value="Number(0)" :false-value="Number(1)"  />
                                    
                                </div>                                            
                            </li>                                          
                        
                        </ul>
                    </Modal>
                    <!-- 确认删除框 -->
                    <Modal
                        v-model="delM"
                        title="提示"
                        @on-ok="delOk"
                        @on-cancel="cancel"
                        class-name="vertical-center-modal"
                    >
                        <p>确定删除吗?</p>
                        
                    </Modal>
                </div>

            </div>

       </div>
       
  </div>

</template>

<script>
    import { mapState,mapMutations,mapGetters } from 'vuex';
    import { format } from 'path';
    

    export default {
        name:'classify',
        data () {
            return {
                route: null,
                token:'',
               

                columns1:[],
                  
                data1:[],
                

                checkGuid2:'',
           
              
  
                modal1: false, // 编辑分类
                modal2: false,   //添加分类
               
                delM: false,

                model1: null,
                model2: null,
                model3: 0,   //是否显示
                model4: ""   //链接
            }
        },
     
        watch:{
           
          
        },
       
        computed: {
         
         
            
        },
        
        methods: {
           load(){
              let that = this;
              
              that.$myAjax.get(
                    'admin/service/admin/news/baidu/content/select'
              ).then(res => {
                   that.columns1 = [
                       {title:'排序',key:'sort',align:'center',},
                       {title:'标题',key:'title',align:'center'},
                       {title:'链接',key:'url',align:'center',minWidth:500,
                            render: (h, params) => {
                                return h('a', {
                                    attrs: { 
                                        href: params.row.url,
                                        target: '_black' 
                                    }
                                },params.row.url)
                            }

                       },
                       {title:'状态',key:'isDisplay',align:'center',
                            render: (h, params) => {
                           
                              return h('i-switch', {
                                      
                                      props: {
                                          size: "large",
                                          value: params.row.isDisplay == "0"
                                      },
                                      on: {
                                          'on-change': (value) => {
                                              let val;
                                              if(value){
                                                val = 0
                                              }else{
                                                val = 1
                                              }

                                              that.$myAjax.put(
                                                    'admin/service/admin/news/baidu/content/update?route=/layout/circle/classify/editor',
                                                    {
                                                        "guid": params.row.guid,
                                                        "isDisplay": val
                                                    },
                                                  
                                              ).then(res => {
                                                
                                          
                                              }).catch(err=>{
                                                  console.log(err)
                                              })


                                          }
                                      }
                                  },
                                  [h('span', {
                                          slot: "open",
                                          domProps: {
                                              innerHTML: '开启'
                                          }
                                      }),
                                      h('span', {
                                          slot: "close",
                                          domProps: {
                                              innerHTML: '关闭'
                                          }
                                      }),
                                  ]
                              )
                            }

                      },
                      {title:'创建时间',key:'createTime',align:'center'},
                      {title:'操作',slot:'btn',align:'center',fixed:'right'}
                   ];
                   that.data1 = res.data.data;
                   
                });
              

                 

              
           },

          
            
           // 用户组名编辑
            editorFun(res){
                let that = this;
               

                that.$canBtn( that.route).then( function(res_c){
                    that.modal1 = true;
    
                    that.guid = res.guid;
                    that.model1 = res.sort;
                    that.model2 = res.title;
                    that.model4 = res.url;
                    
                })
            },
           

            //    编辑弹窗
            ok1() {
                var that = this;
                that.$myAjax.put(
                    'admin/service/admin/news/baidu/content/update?route=/layout/circle/classify/editor',
                    {
                        "guid": that.guid,
                        "sort": that.model1,
                        "title": that.model2,
                        "url": that.model4
                    },
                  
                ).then(res => {
                   
                    if(res.data.code == 1){
                        that.load();
                        that.cancel1();
                    }
                }).catch(err=>{
                    console.log(err)
                })

                
                
            },
            cancel1() {
                this.modal1 = false;
               
               
            },
           
            // 删除用户组
            delFun(res){
                let that = this;

                that.guid = res.guid;
                that.$canBtn( that.route).then( function(res_c){
                    that.guid = res.guid;
                    that.delM = true;
                })
            },
            delOk(){
                let that = this;
                that.$myAjax.delete(
                    'admin/service/admin/news/baidu/content/delete?guid='+that.guid+'&route='+that.route,
                    {
                    },
                   
                ).then(res => {
                    console.log(111)
                    that.load();
                })
                
            },
            
            
            // 顶部添加
            
            addFun(){
                let that = this;
                
                that.$canBtn( that.route).then( function(res_c){
                    that.modal2 = true;

                    that.model1 = null;
                    that.model2 = null;
                    that.model3 = 0;
                    that.model4 = null;
                })
            },
            ok_add(){
                let that = this;
                
                that.$myAjax.post(
                    'admin/service/admin/new/baidu/content/add?route='+that.route,
                    {
                        sort: that.model1,
                        title: that.model2,
                        isDisplay: that.model3,
                        url: that.model4
                    },
                    
                ).then(res => {
                  
                    if(res.data.code != 0){
                        that.load();
                        that.cancel_add();
                    }
                    
                })
                    
                
               
            },
            cancel_add(){
            
                this.modal2 = false;
            },

            cancel(){},

         
        },
        mounted: function(){
           var that = this;
           that.vCropper = that.$store.state.vCropper;
           
           that.token = that.$store.state.token;
           
           that.load();
         
        }
    }
</script>
<style scoped>
     /* public 内容用  /就行 */
     @import "/css/modal.css";

     /* 表格下方无翻页按钮时 */
    .ivu-table-wrapper{
        margin-bottom: 50px;
    }

    
</style>




